import routes from "../../utils/constants/apiRoutes";
import { createSlice, Dispatch } from '@reduxjs/toolkit'
import axios from "../../utils/axios";
import { searchParams } from "src/@types/data";

export function fetchAllUsers(filters?: any, signal?: AbortSignal, orgCode?: string) {
    return async function getUsersData(dispatch: Dispatch, getState: any) {
        try {
            const searchParams: searchParams = filters

            const queryString = "?" + new URLSearchParams(<URLSearchParams>searchParams).toString();
            const response = await axios.get(orgCode ? `${orgCode}${routes.USERS}${queryString}` : `${routes.USERS}${queryString}`, { signal });
            return response;
        } catch (e) {
            console.log("error while fetchUsersData", e);
            throw e;
        }
    };
}

export function addUser(userData: any, orgCode?: string) {
    return async function getUsersData(dispatch: Dispatch, getState: any) {
        try {
            const headers = {
                'Content-Type': 'multipart/form-data',
            }
            const response = await axios.post(orgCode ? `${orgCode}${routes.USERS}` : `${routes.USERS}`, userData, { headers });
            return response;
        } catch (e) {
            console.log("error while fetchUsersData", e);
        }
    };
}

export function fetchUserById(id: any, orgCode?: string) {
    return async function getUsersData(dispatch: Dispatch) {
        try {
            const response = await axios.get(orgCode ? `${orgCode}${routes.USERS}/${id}` : `${routes.USERS}/${id}`);
            return response?.data;
        } catch (e) {
            console.log("error while fetchUserData", e);
            throw e;
        }
    };
}

export function updateUser(userData: any, orgCode?: string) {
    return async function updateUsersData(dispatch: Dispatch, getState: any) {
        try {
            const headers = {
                'Content-Type': 'multipart/form-data',
            }
            const response = await axios.put(orgCode ? `${orgCode}${routes.USERS}/update` : `${routes.USERS}/update`, userData, { headers });
            return response;
        } catch (e) {
            console.log("error while fetchUsersData", e);
            throw e;
        }
    };
}

export function updateUserSettings(userData: any, orgCode?: string) {
    return async function updateUsersData(dispatch: Dispatch, getState: any) {
        try {
            const headers = {
                'Content-Type': 'multipart/form-data',
            }
            const response = await axios.put(orgCode ? `${orgCode}${routes.AUTH}/update` : `${routes.AUTH}/update`, userData, { headers });
            return response?.data;
        } catch (e) {
            console.log("error while fetchUsersData", e);
            throw e;
        }
    };
}

/**
 * Saves the notification token for a user.
 * @param {string} userId - The ID of the user.
 * @param {string | null} notificationToken - The notification token to be saved.
 * @returns {Promise<boolean>} - A promise that resolves to true if the notification token is saved successfully.
 */

export function saveNotificationToken(userId: string, notificationToken: string | null, orgCode?: string) {
    return async function createNotificationToken() {
        try {
            const headers = {
                'Content-Type': 'application/json',
            }
            axios.post(orgCode ? `${orgCode}${routes.USERS}/deviceDetail` : `${routes.USERS}/deviceDetail`, { userId, notificationToken }, { headers });
            return true;
        } catch (e) {
            console.log("error while fetchUsersData", e);
        }
    };
}

export function SendEmailVerificationLink(email: any, orgCode?: string) {
    return async function SendEmailVerificationLink() {
        try {
            const response = await axios.post(orgCode ? `${orgCode}${routes.AUTH}/verify-email` : `${routes.AUTH}/verify-email`, { email });
            return response?.data;
        } catch (e) {
            console.log("error while SendEmailVerificationLink", e);
            throw e;
        }
    };
}

export function SendVerificationOtp(phonenumber: any, orgCode?: string) {
    return async function SendEmailVerificationLink() {
        try {
            const response = await axios.post(orgCode ? `${orgCode}${routes.AUTH}/verify-mobile` : `${routes.AUTH}/verify-mobile`, { phonenumber });
            return response?.data;
        } catch (e) {
            console.log("error while SendEmailVerificationLink", e);
            throw e;
        }
    };
}

export function emailVerification(token: any, orgCode?: string) {
    return async function emailVerification() {
        try {
            const response = await axios.post(orgCode ? `${orgCode}${routes.AUTH}/verify-email-token/${token}` : `${routes.AUTH}/verify-email-token/${token}`);
            return response?.data;
        } catch (e) {
            console.log("error while emailVerification", e);
            throw e;
        }
    };
}

export function searchUser(filters?: any, signal?: AbortSignal, orgCode?: string) {
    return async function searchUser(dispatch: Dispatch, getState: any) {
        try {
            const searchParams: searchParams = filters

            const queryString = "?" + new URLSearchParams(<URLSearchParams>searchParams).toString();
            const response = await axios.get(orgCode ? `${orgCode}${routes.USERS}/search${queryString}` : `${routes.USERS}/search${queryString}`, { signal });
            return response;
        } catch (e) {
            console.log("error while searchUser", e);
            throw e;
        }
    };
}

export function fetchCountOfAllUser(orgCode?: string) {
    return async function fetchCountOfAllUser() {
        try {
            const response = await axios.get(orgCode ? `${orgCode}${routes.USERS}/count` : `${routes.USERS}/count`);
            return response?.data;
        } catch (e) {
            console.log("error while fetchCountOfAllUser", e);
            throw e;
        }
    };
}